module.exports = "/_next/static/images/90e50fbb0a0388a55096c4177e973c61-mb-hero-lg-experiment.jpg";